import { useEffect, useState } from 'react'
import { useTranslation } from '@pancakeswap/localization'
import { toast } from 'sonner'

/**
 * Hook to handle PWA updates
 * This hook will register a service worker and listen for updates
 * When an update is available, it will show a toast notification
 * When the user clicks the toast, it will reload the page to apply the update
 */
export const usePwaUpdate = () => {
  const { t } = useTranslation()
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null)

  // Register service worker
  useEffect(() => {
    const registerServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const reg = await navigator.serviceWorker.register('/service-worker-sw.js')
          setRegistration(reg)

          // Check if there's an update when the service worker is updated
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker is installed but waiting to be activated
                  setUpdateAvailable(true)

                  // Show toast notification
                  toast(t('Update Available'), {
                    description: t('A new version is available. Click here to update.'),
                    action: 'installed',
                    // onClick: () => {
                    //   Send message to service worker to skip waiting
                    // newWorker.postMessage({ type: 'SKIP_WAITING' })
                    //
                    // Reload the page to apply the update
                    // window.location.reload()
                    // },
                  })
                }
              })
            }
          })

          // Check for updates every 60 minutes
          setInterval(() => {
            reg.update().catch(console.error)
          }, 60 * 60 * 1000)
        } catch (error) {
          console.error('Service worker registration failed:', error)
        }
      }
    }

    registerServiceWorker()
  }, [t])

  // Listen for controller change events
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // The service worker controller has changed, reload the page
        window.location.reload()
      })
    }
  }, [])

  return { updateAvailable, registration }
}

export default usePwaUpdate
